import { Action, createReducer, on } from '@ngrx/store';
import { BadResponseWithError } from '@shared/models/common.interface';
import {
    PlayerProfilesWithPagination,
    ProfileInfo,
} from '../../models/api/response/user-management.response';
import { UserManagementActions } from '../actions/actions-type.action';

export interface UserManagementState {
    profiles: PlayerProfilesWithPagination | null;
    currentProfileInfo: ProfileInfo | null;
    isLoading: boolean;
    error: BadResponseWithError | null;
    currentProfileLogs: any; // PROFILE LOG TYPE
}

const initialState: UserManagementState = {
    profiles: null,
    currentProfileInfo: null,
    isLoading: false,
    error: null,
    currentProfileLogs: null,
};

const reducer = createReducer(
    initialState,
    on(UserManagementActions.fetchUsers, (state) => ({
        ...state,
        isLoading: true,
    })),
    on(UserManagementActions.fetchUsersSuccess, (state, action) => ({
        ...state,
        profiles: action.payload,
        isLoading: false,
    })),
    on(UserManagementActions.fetchUsersFailure, (state, action) => ({
        ...state,
        isLoading: false,
        error: action.payload,
    })),
    on(UserManagementActions.fetchProfileInfo, (state) => ({
        ...state,
        currentProfileInfo: null,
        isLoading: true,
    })),
    on(UserManagementActions.fetchProfileInfoSuccess, (state, action) => ({
        ...state,
        currentProfileInfo: action.payload,
        isLoading: false,
    })),
    on(UserManagementActions.fetchProfileInfoFailure, (state, action) => ({
        ...state,
        isLoading: false,
        error: action.payload,
    })),
    on(UserManagementActions.profileTurnOff2fa, (state) => ({
        ...state,
        isLoading: true,
    })),
    on(UserManagementActions.profileTurnOff2faSuccess, (state, action) => ({
        ...state,
        currentProfileInfo: {
            ...state.currentProfileInfo,
            is2faEnabled: false,
        } as ProfileInfo,
        isLoading: false,
    })),
    on(UserManagementActions.profileTurnOff2faFailure, (state, action) => ({
        ...state,
        isLoading: false,
        error: action.payload,
    })),
    on(UserManagementActions.fetchProfileTournaments, (state) => ({
        ...state,
        isLoading: true,
    })),
    on(
        UserManagementActions.fetchProfileTournamentsSuccess,
        (state, action) => ({
            ...state,
            currentProfileInfo: {
                ...state.currentProfileInfo,
                tournaments: action.payload.items,
            } as ProfileInfo,
            isLoading: false,
        })
    ),
    on(
        UserManagementActions.fetchProfileTournamentsFailure,
        (state, action) => ({
            ...state,
            isLoading: false,
            error: action.payload,
        })
    ),
    on(UserManagementActions.fetchUserIpLogs, (state, action) => ({
        ...state,
        isLoading: true,
    })),
    on(UserManagementActions.fetchUserIpLogsSuccess, (state, action) => ({
        ...state,
        currentProfileLogs: action.payload,
        isLoading: false,
    })),
    on(UserManagementActions.fetchUserIpLogsFailure, (state, action) => ({
        ...state,
        isLoading: false,
        error: action.payload,
    }))
);

export const userManagementReducer = (
    state: UserManagementState,
    action: Action
) => reducer(state, action);
